import { defineStore } from "pinia";
import { ref } from "vue";

export const userUserStore = defineStore(
  "user",
  () => {
    const user = ref(null);
    const authenticated = ref(false);

    // actions
    const setUser = (userData) => {
      user.value = userData;
    };

    const logout = () => {
      user.value = null;
    };

    const isLoggedIn = () => !!user.value;

    return { user, setUser, logout, isLoggedIn };
  },
  {
    persist: true, //salva automaticamente no localstora
  }
);
